// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import GlobalStyles from '../../../../config/styles';

const styles = theme => ({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '20px 50px',
    width: '100%',
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    color: GlobalStyles.color.COLOR_GREY,
  },
  mainInfoContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: '5px 0',
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    [theme.breakpoints.down(750)]: {
      flexDirection: 'column',
    },
  },
  fontBold: {
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
    marginLeft: 5,
  },
  mainInfoSubContainer: {
    width: '33.3%',
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.down(850)]: {
      width: 'fit-content',
    },
  },
  toStart: {
    justifyContent: 'flex-start',
  },
  toEnd: {
    justifyContent: 'flex-end',
    [theme.breakpoints.down(650)]: {
      justifyContent: 'flex-start',
    },
  },
  imageOk: {
    width: 18,
    height: 18,
    marginRight: 5,
  }
});

export default styles;
